module.exports = __webpack_public_path__ + "static/img/cp.070f4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp.png
// module id = 552
// module chunks = 1